<div class="edit-page-root-container reason-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission?.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="description-field" style="width: 100%;">
                                    <mat-label>Description</mat-label>
                                    <textarea matInput formControlName="description" rows="3" placeholder="Enter reason description"></textarea>
                                    <mat-error *ngIf="editForm.get('description')?.hasError('required')">Description is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="display-order-field" style="width: 250px;">
                                    <mat-label>Display Order</mat-label>
                                    <input matInput type="number" formControlName="display_order" min="0" placeholder="0">
                                    <mat-error *ngIf="editForm.get('display_order')?.hasError('required')">Display order is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
